export class CollectionLayout extends HTMLElement {
  constructor() {
    super();
    this.collection = document.querySelector("motion-list.card-grid");
    this.toggle = document.querySelector(".mobile-grid-toggle");
  }

  connectedCallback() {
    this.bindEvents();
    this.renderFromCache();
  }

  bindEvents() {
    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", () => this.setLayout(button));
    });
  }

  renderFromCache() {
    let cachedLayout = localStorage.getItem("mobileCollectionGrid");

    if (!cachedLayout) {
      // default to grid if nothing saved
      cachedLayout = "grid";
      localStorage.setItem("mobileCollectionGrid", cachedLayout);
    }

    const button = this.querySelector(`button[data-layout-type="${cachedLayout}"]`);
    if (button) {
      this.setLayout(button);
    }
  }

  setLayout(button) {
    const layoutType = button.dataset.layoutType;

    // Reset active state
    this.querySelectorAll("button").forEach((el) => el.classList.remove("active"));

    // Update collection layout classes
    this.collection.classList.remove("mobile:card-grid--1", "mobile:card-grid--2");
    this.collection.classList.add(layoutType === "single" ? "mobile:card-grid--1" : "mobile:card-grid--2");

    // Toggle modifier class on <collection-layout>
    this.toggle.classList.toggle("is-grid", layoutType !== "single");

    // Mark active button
    button.classList.add("active");

    // Save Local storage
    localStorage.setItem("mobileCollectionGrid", layoutType);
  }
}

customElements.define("collection-layout", CollectionLayout);
